const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  content: {
    ...theme.mainContent,
    maxWidth: "780px",
    width: "100%",
    margin: "0 auto",
    padding: 15,
  },
  header: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 100,
    background: "#fff",
    padding: "0px 10px",
    // boxShadow: "0 4px 10px -4px rgba(0,0,0,.07)",
    "@media print": {
      display: "none",
    },
  },
  contentLG: {
    maxWidth: "1280px",
  },
  contentMD: {
    maxWidth: "1100px",
  },
  contentFull: {
    maxWidth: "100%",
  },
  contentDashboard: {
    background: "#f7f8fa",
    minHeight: "100vh",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `
        radial-gradient(circle at 20% 80%, rgba(37, 99, 235, 0.4), transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.12), transparent 50%),
        radial-gradient(circle at 40% 40%, rgba(30, 64, 175, 0.3), transparent 50%)
      `,
      pointerEvents: "none",
    },
  },
}));
